import { CustomBottomBar, FileUploader } from '@components';
import { Button, Container, Dropdown, Textarea, Typography } from '@design-system';
import { EcsModule } from '@services';
import React from 'react';
import './EventFeedbackPage.scss';
import { useEventFeedbackPageVM } from './useEventFeedbackPageVM';

export type EventFeedbackPageProps = {
    eventDestination: EcsModule | null;
};

export const EventFeedbackPage: React.FC<EventFeedbackPageProps> = ({ eventDestination }) => {
    const {
        eventFeedbackToCreate,
        handleFieldChange,
        filteredEventTypes,
        operatorsOptions,
        worksitesOptions,
        destinations,
        files,
        setFiles,
        handleCreateEventFeedback,
        isFeedBackFilled,
        isRhDestination
    } = useEventFeedbackPageVM({ eventDestination });

    return (
        <div className="event-feedback-page">
            <Container padding="none">
                <Container className="wrapper">
                    <Container bordered="grey" className="event-feedback-form mt-medium-spacing">
                        <Typography intrinsic="h3" className="pl-small-spacing">
                            {isRhDestination ? 'Nouvelle remontée RH' : 'Nouvelle remontée'}
                        </Typography>

                        <Dropdown
                            placeholder="Choisir un évènement"
                            options={destinations}
                            value={destinations.find((destination) => destination.id === eventFeedbackToCreate.event_destination)}
                            onOptionChange={(option) => {
                                handleFieldChange('event_destination', option.id);
                            }}
                        />
                        {!isRhDestination && (
                            <>
                                <Dropdown
                                    options={operatorsOptions}
                                    placeholder="Responsable"
                                    onOptionChange={(option) => {
                                        handleFieldChange('operator_id', option.id);
                                    }}
                                    value={operatorsOptions.find((operator) => operator.id === eventFeedbackToCreate.operator_id)}
                                />

                                <Dropdown
                                    options={worksitesOptions}
                                    placeholder="Chantier"
                                    onOptionChange={(option) => {
                                        handleFieldChange('worksite_id', option.id);
                                    }}
                                    value={
                                        eventFeedbackToCreate.worksite_id && worksitesOptions.length > 0
                                            ? worksitesOptions.find((worksite) => worksite.id === eventFeedbackToCreate.worksite_id) || null
                                            : null
                                    }
                                    isSearchable={true}
                                />
                            </>
                        )}

                        <Dropdown
                            placeholder={isRhDestination ? 'Type de remontée' : "Type d'évènement"}
                            options={filteredEventTypes.map((eventType) => ({
                                id: eventType.id.toString(),
                                label: eventType.label
                            }))}
                            onOptionChange={(option) => {
                                handleFieldChange('event_type', option.id);
                            }}
                            value={
                                eventFeedbackToCreate.event_type && filteredEventTypes.length > 0
                                    ? (() => {
                                          const found = filteredEventTypes.find(
                                              (eventType) => eventType.id === parseInt(eventFeedbackToCreate.event_type)
                                          );
                                          return found ? { id: found.id.toString(), label: found.label } : null;
                                      })()
                                    : null
                            }
                        />

                        <Textarea
                            placeholder="Commentaire"
                            value={eventFeedbackToCreate.comment}
                            onValueChange={(value: string) => handleFieldChange('comment', value)}
                        />
                    </Container>
                </Container>

                <FileUploader files={files} setFiles={setFiles} />
            </Container>

            <CustomBottomBar>
                <Button variant="primary" onClick={handleCreateEventFeedback} size="fullwidth" color="marine" disabled={!isFeedBackFilled}>
                    <Typography intrinsic="h4">Envoyer</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
